import { appEnv } from 'src/util/appEnv'

/**
 * 新規顧客と既存顧客を区別するための company_id 閾値。
 *
 * この値以下の company_id を持つ企業は「既存顧客」として扱い、
 * 表形式ひな形・取込み項目・レイアウト選択など段階的に廃止予定の機能を引き続き利用できる。
 *
 * この値より大きい company_id を持つ企業は「新規顧客」として扱い、
 * 上記機能は非表示となる。
 *
 * 将来的に全顧客で廃止する際は、この定数を参照している分岐ごと削除する。
 */
const getLegacyCompanyIdThreshold = (): number => {
  if (appEnv.isLocal) return 2
  if (appEnv.isDevelopment) return 2
  // production
  return 1417
}

export const LEGACY_COMPANY_ID_THRESHOLD = getLegacyCompanyIdThreshold()
